var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return ((_vm.icon != null))?_c('div',{class:_vm.GetClass()}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }